<template>
<!--    热点资讯-->
  <div id="articlelist">
    <article-head></article-head>
    <h2 class="title">
      <a @click="back" class="prev"></a>
      热点资讯
    </h2>
    <ul class="nav">
      <li v-for="(item, index) in navData" :key="index" v-text="item.name" :class="{active: selectNav === index}" @click="clickNav(index, item.type_id)"></li>
    </ul>
    <main-list :typeId="typeId"></main-list>
  </div>
</template>

<script>
import articleHead from '../share/header/articleHead'
import mainList from './ArticleListMain'
export default {
  name: 'ArticleList',
  data () {
    return {
      recentData: [],
      navData: {},
      page: 1,
      length: 8,
      loading: false,
      maxPage: 0,
      has: true,
      selectNav: 0,
      typeId: 1 // 1 考试资讯 2 教师招聘 3 教师公告 4备考资料
    }
  },
  components: {
    mainList,
    articleHead
  },
  methods: {
    back () {
      if (window.history.length <= 1) {
        this.router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    },
    // 获得分类信息
    getNav () {
      let data = {
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_news_type',
        params: data,
        headers: {
          'sign': this.$encryption(data)
        }
      })
        .then(res => {
          console.log(res)
          this.navData = res.data.data
        })
        .catch(err => { console.log(err) })
    },
    listenScroll () {
      let self = this
      $(window).scroll(function () {
        let scrollTop = $(window).scrollTop()
        let windowTop = $(window).height()
        let documentTop = $(document).height()
        if (documentTop - windowTop <= scrollTop) {
          self.page++
          self.loading = true
          self.getRecent()
          self.loading = false
        }
      })
    },
    clickNav (num, typeid) {
      this.selectNav = num
      this.typeId = typeid
    }
  },
  mounted () {
    this.getNav()
    // this.getRecent()
    this.listenScroll()
  },
  beforeDestroy () {
    $(window).unbind('scroll')
  }
}
</script>

<style scoped lang="stylus">
  #articlelist
    /*background-color: #F9F9F9*/
    .title
      position: relative
      height: 1.08rem
      line-height: .8rem
      background-color: transparent
      padding: .14rem .16rem
      font-size: .4rem
      color: #050505
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        width: .8rem
        height: .8rem
        background-color: #fff
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #050505
          border-bottom: .03rem solid #050505
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
  .nav
    display: flex
    justify-content: space-between
    align-items: center
    height: .8rem
    background-color: #F9F9F9
    padding: 0 .4rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    li
      font-size: .32rem
      color: #343434
      &.active
        position: relative
        color: #1E81F2
        font-weight: 600
        &::after
          content: ""
          position: absolute
          bottom: -.18rem
          left: 50%
          display: block
          width: .54rem
          height: .06rem
          background-color: #1E81F2
          -webkit-transform: translate(-50%, 0)
          -moz-transform: translate(-50%, 0)
          -ms-transform: translate(-50%, 0)
          -o-transform: translate(-50%, 0)
          transform: translate(-50%, 0)
  #zjgx
    width: 7.1rem
    padding: 0 .2rem .3rem
    background-color: #fff
    margin: 0 auto
    -webkit-border-radius: .16rem
    -moz-border-radius: .16rem
    border-radius: .16rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    .main
      li
        display: flex
        justify-content: space-between
        width: 100%
        height: 1.86rem
        padding: .32rem 0
        border-bottom: .01rem solid #EFEFEF
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        .left
          width: 1.6rem
          height: 1.24rem
          -webkit-border-radius: .08rem
          -moz-border-radius: .08rem
          border-radius: .08rem
          img
            width: 100%
        .right
          width: 4.9rem
          height: 1.24rem
          p
            overflow: hidden
            width: 100%
            height: .84rem
            font-size: .3rem
            color: #0C0C0C
          p + .tag
            font-size: .22rem
            color: #9DA4B3
            text-align: right
  p.cue
    text-align: center
</style>



// WEBPACK FOOTER //
// src/components/article/ArticleList.vue